import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "p-the-header-navi-on-general__navi__item" }
const _hoisted_3 = { class: "p-the-header-navi-on-general__navi__item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconFaqBalloon = _resolveComponent("IconFaqBalloon")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_NaviItemLinkForSpOnGeneral = _resolveComponent("NaviItemLinkForSpOnGeneral")!
  const _component_IconMail = _resolveComponent("IconMail")!

  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      true
        ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
            _createElementVNode("li", _hoisted_2, [
              _createVNode(_component_NaviItemLinkForSpOnGeneral, {
                url: _ctx.urlFAQ,
                label: "FAQ",
                "icon-color": "transparent"
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_IconBase, {
                    width: 20,
                    height: 20,
                    "view-box": "0 0 23 27",
                    "icon-color": _ctx.iconColor
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_IconFaqBalloon)
                    ]),
                    _: 1
                  }, 8, ["icon-color"])
                ]),
                _: 1
              }, 8, ["url"])
            ]),
            _createElementVNode("li", _hoisted_3, [
              _createVNode(_component_NaviItemLinkForSpOnGeneral, {
                url: _ctx.urlNotification,
                label: "お問い合わせ",
                "icon-color": "transparent"
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_IconBase, {
                    width: 20,
                    height: 20,
                    "view-box": "0 0 24 24",
                    "icon-color": "transparent"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_IconMail)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["url"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}